import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "step";
var classes = {
    STEP: 'tyl-step',
    STEP_CONTAINER: 'tyl-step__container',
    ERROR: 'tyl-step--error',
    SELECTED: 'tyl-step--selected',
    COMPLETED: 'tyl-step--completed',
    EDITABLE: 'tyl-step--editable',
    ALTERNATIVE: 'tyl-step--alternative',
    ICON_CONTENT: 'tyl-step-icon-content',
    ICON: 'tyl-step-icon',
    LABEL_CONTAINER: 'tyl-step-label-container',
    LABEL: 'tyl-step-label',
    OPTIONAL_LABEL: 'tyl-step-optional-label',
    INDEX: 'tyl-step-index',
    CLUSTERED: 'tyl-step--clustered',
    DISABLED: 'tyl-step--disabled',
    VERTICAL: 'tyl-step--vertical',
    EXPANDED: 'tyl-step--expanded',
    EXPANDABLE: 'tyl-step--expandable',
    EXPANSION_PANEL: 'tyl-step__expansion-panel',
    EXPANSION_ICON: 'tyl-step__expanded-icon',
    EXPANSION_ICON_EXPANDED: 'tyl-step__expanded-icon--expanded',
    EXPANSION_CONTENT: 'tyl-step__expansion-content',
};
var attributes = {
    SELECTED: "selected",
    INDEX: "index",
    EDITABLE: "editable",
    COMPLETED: "completed",
    ERROR: "error",
    ALTERNATIVE: 'alternative',
    FIRST: 'first',
    LAST: 'last',
    ARIA_SELECTED: 'aria-selected',
    CLUSTERED: "clustered",
    DISABLED: 'disabled',
    VERTICAL: 'vertical',
    EXPANDED: 'expanded',
    EXPANDABLE: 'expandable',
    IGNORE_USER_EXPANSION: 'ignore-user-expansion',
};
var selectors = {
    STEP: "." + classes.STEP,
    STEP_CONTAINER: "." + classes.STEP_CONTAINER,
    INDEX: "." + classes.INDEX,
    ICON: "." + classes.ICON,
    ICON_CONTENT: "." + classes.ICON_CONTENT,
    EXPANSION_SLOT: "slot[name=\"expansion-content\"]",
    EXPANSION_PANEL: "." + classes.EXPANSION_PANEL,
    EXPANSION_ICON: "." + classes.EXPANSION_ICON,
};
var strings = {
    ARROW_LEFT_KEY: 'ArrowLeft',
    ARROW_RIGHT_KEY: 'ArrowRight',
    ARROW_UP_KEY: 'ArrowUp',
    ARROW_DOWN_KEY: 'ArrowDown',
    END_KEY: 'End',
    ENTER_KEY: 'Enter',
    HOME_KEY: 'Home',
    SPACE_KEY: 'Space',
    EXPANSION_CONTENT_SLOT_NAME: 'expansion-content'
};
var events = {
    SELECTED: elementName + "-selected",
    EXPANDED_CONTENT_FOCUSIN: elementName + "-expanded-content-focusin",
    EXPANDED_CONTENT_FOCUSOUT: elementName + "-expanded-content-focusout",
};
export var STEP_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    events: events,
    strings: strings
};
